<section class="app-page">
  <div class="px-12 py-6">
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold">Bus Stop Dashboard</h1>
      <button (click)="refreshData()" class="btn btn-ghost btn-sm" [disabled]="myDashboardQuery.isFetching()">
        <span class="loading loading-spinner loading-xs" *ngIf="myDashboardQuery.isFetching()"></span>
        <span *ngIf="!myDashboardQuery.isFetching()">Refresh</span>
      </button>
    </div>

    @if (myDashboardQuery.isInitialLoading()) {
      <div class="flex justify-center items-center h-64">
        <span class="loading loading-spinner loading-lg"></span>
      </div>
    } @else if (myDashboardQuery.isError()) {
      <div class="alert alert-error">
        <span>Error loading dashboard data. Please try again.</span>
        <button class="btn btn-sm btn-ghost" (click)="refreshData()">Retry</button>
      </div>
    } @else {
      <!-- Stats Cards Row -->
      <div class="mb-6">
        <buspro-admin-daily-stats-card [stats]="statistics() || null"></buspro-admin-daily-stats-card>
      </div>

      <!-- Main Content Grid -->
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <!-- Left Column: Assigned Locations + Approaching Buses -->
        <div class="lg:col-span-2 space-y-6">
          <!-- Assigned Locations Card -->
          <buspro-admin-assigned-locations-card
            [locations]="assignedLocations()"
            [selectedLocationId]="selectedLocationId()"
            (locationSelected)="onLocationSelected($event)"
          ></buspro-admin-assigned-locations-card>

          <!-- Approaching Buses Widget -->
          <buspro-admin-approaching-buses-widget
            [buses]="approachingBusesSignal()"
            [isLoading]="isLoadingSignal()"
            [hasError]="hasErrorSignal()"
            [showMap]="true"
            [locationCenter]="getLocationCenter()"
            (bookSeat)="openBookingModal($event)"
            (retry)="refreshData()"
          ></buspro-admin-approaching-buses-widget>
        </div>

        <!-- Right Column: Recent Bookings -->
        <div>
          <buspro-admin-recent-bookings-table [bookings]="recentBookings()" [limit]="10"></buspro-admin-recent-bookings-table>
        </div>
      </div>
    }
  </div>
</section>

<!-- Booking Modal -->
<buspro-admin-live-booking-modal
  [visible]="showBookingModal()"
  [selectedBus]="selectedBusForBooking()"
  [bookingLocationId]="getBookingLocationId()"
  [bookingLocationType]="getBookingLocationType()"
  (visibleChange)="showBookingModal.set($event)"
  (bookingSuccess)="onBookingSuccess()"
></buspro-admin-live-booking-modal>
